import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PotentialJobCustomCostCodeService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get custom codes based on job id and department id
  getCustomCostCode(jobId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_custom_cost_codes/' + jobId;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to create job's department custom task code
  createCustomCostCode(customTaskCodeInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_custom_cost_codes/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = customTaskCodeInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update specific role
  updateCustomCostCode(id, customTaskCodeInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_custom_cost_codes/update/' + id;
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = customTaskCodeInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to delete specific role
  deleteCustomCostCode(id, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_custom_cost_codes/delete/' + id;
    this.HttpRequestModel.method = 'DELETE';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to check exist custom cost code
  checkCustomCostCode(codeArr, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_custom_cost_codes/checkCode';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = codeArr;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
